import { cva } from 'class-variance-authority';

export const cvaFabButton = cva(
  [
    'fixed bottom-4 right-4 z-[100]',
    'flex items-center justify-center',
    'w-10 h-10 rounded-full',
    'bg-general_MI_500_default hover:bg-general_MI_600_hover',
    'text-white shadow-lg',
    'transition-all duration-200',
    'cursor-pointer',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-general_MI_500_default',
  ],
  {
    variants: {
      isOpen: {
        true: 'ring-2 ring-general_MI_500_default',
        false: '',
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);

export const cvaPopoverContent = cva([
  'w-[280px] p-3',
  'bg-general_background_MI_500_light',
  'rounded-lg shadow-xl',
  'border border-general_background_MIII_500_dark',
]);

export const cvaTourCard = cva(
  [
    'flex items-center gap-3 p-2.5',
    'rounded-lg',
    'transition-colors duration-150',
    'cursor-pointer',
  ],
  {
    variants: {
      disabled: {
        true: 'opacity-50 cursor-not-allowed',
        false: 'hover:bg-general_background_MIII_500_dark',
      },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);
